export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return
  }

  const publicRoutes = ['/auth', '/sso']

  const toPath = String(to.path).replace(/\/$/, '')

  if (publicRoutes.includes(toPath)) {
    return
  }

  const userStore = useUserStore()
  const { isAuthenticated } = storeToRefs(userStore)

  await nextTick()

  if (!isAuthenticated.value) {
    return navigateTo('/auth', { replace: true })
  }
})
